export default "__VITE_ASSET__CBG51nf2__"